"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tlds_1 = __importDefault(require("tlds"));
var emailsToValidate_1 = require("../utils/emailsToValidate");
var validateTopLevelEmailDomain = function (emailDomain) {
    var lastDot = emailDomain.lastIndexOf('.');
    var tld = emailDomain.substring(lastDot + 1);
    if (!tlds_1.default.includes(tld)) {
        return true;
    }
    return false;
};
var validateEmail = function (value) {
    var lowerCaseEmail = value.toLocaleLowerCase();
    var accentRegex = /[À-ú]/;
    var hasAccent = accentRegex.test(lowerCaseEmail);
    if (hasAccent) {
        return 'Corrija seus dados. Insira somente letras (a-z), números (0-9) e pontos (.) no campo do email.';
    }
    var emailRegex = /^(([^<>()[\]\\ç.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var isValid = emailRegex.test(lowerCaseEmail);
    if (!isValid) {
        return 'Corrija seus dados. Insira o email no formato: nome@exemplo.com.br';
    }
    var atPosition = lowerCaseEmail.indexOf('@');
    var emailDomain = lowerCaseEmail.substring(atPosition + 1, lowerCaseEmail.length);
    if (emailsToValidate_1.emailsToValidate.includes(emailDomain) || validateTopLevelEmailDomain(emailDomain)) {
        return 'Corrija seus dados. Email com domínio inválido.';
    }
    var isCharacterLimit = atPosition > 64;
    if (isCharacterLimit) {
        return 'Corrija seus dados. O endereço de email ultrapassa o limite máximo de 64 caracteres.';
    }
    return false;
};
exports.default = validateEmail;
//# sourceMappingURL=email.js.map